<template>
    <form class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '詳細資料'"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                
                <div class="md minor-table">
                    <table>
                        <tbody>
                            <template v-for="$title in title">
                                <tr :key="$title.prop" v-if="$title.visible && $title.prop !== 'func'">
                                    <th><label :for="$title.prop">{{ $title.caption }}</label></th>
                                    <td>
                                        <!-- text -->
                                        <div
                                            class="in"
                                            v-if="$title.showtype === 'text'"
                                        >{{ textFormatter(result[$title.prop]) }}</div>
                                        <!-- number -->
                                        <div
                                            class="in is-number"
                                            v-else-if="$title.showtype === 'number'"
                                        >{{ $okaTool.numberToStringFormat(result[$title.prop]) }}</div>
                                        <!-- label -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'label'"
                                        >
                                            <cpLabel
                                                :themes="$title.themes || 'is-major'"
                                                extendClass="is-tag"
                                                :text="textFormatter(result[$title.prop])"
                                            ></cpLabel>
                                        </div>
                                        <!-- boolean -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'boolean'"
                                        >
                                            <cpLabel
                                                v-if="result[$title.prop] !== '' && result[$title.prop] !== undefined"
                                                :themes="$title.themes || 'is-major'"
                                                extendClass="is-circle"
                                                :icon="[result[$title.prop] === true? 'done': '', result[$title.prop] === false? 'close': '', result[$title.prop] === null? 'pause': '', result[$title.prop] !== undefined? 'is-'+ result[$title.prop]: '']"
                                            ></cpLabel>
                                        </div>
                                        <!-- color -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'color'"
                                        >
                                            <div class="cp input color">
                                                <input type="color" :value="result[$title.prop]" disabled>
                                            </div>
                                        </div>
                                        <!-- year -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'year'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).y
                                        }}</div>
                                        <!-- month -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'month'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).ym.replace(/\-/g, '/')
                                        }}</div>
                                        <!-- date -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'date'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).ymd.replace(/\-/g, '/')
                                        }}</div>
                                        <!-- hours -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'hours'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).ymdh.replace(/\-/g, '/') +':00'
                                        }}</div>
                                        <!-- minutes -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'minutes'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).ymdhm.replace(/\-/g, '/')
                                        }}</div>
                                        <!-- time -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'time'"
                                        >{{
                                            $okaTool.timeInterval({
                                                time: result[$title.prop],
                                                unit: 'date'
                                            }).t
                                        }}</div>
                                        <!-- html -->
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'html' && title.inputtype === 'color'"
                                        >
                                            <input
                                                type="color"
                                                style="cursor: default;"
                                                :value="result[$title.prop]"
                                                disabled
                                            >
                                        </div>
                                        <div
                                            class="in"
                                            v-else-if="$title.showtype === 'html'"
                                            v-html="result[$title.prop]"
                                        ></div>
                                        <!-- 其他就當作文字格式化的 html -->
                                        <div
                                            class="in"
                                            v-else
                                            v-html="textFormatter(result[$title.prop])"
                                        ></div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import cpLabel from '@/components/cpLabel'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
            cpLabel,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let result = this.content,
                $node = result.node;

            let $clone = this.$okaTool.copy($node);

            delete $clone.show;
            delete $clone.func;
            delete $clone.page;
            delete $clone.sn;

            return {
                result: $clone
            }
        },
        computed: {
            title: function() {
                return this.content.title || []
            },
            btns: function(){
                let $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                return [
                    $cancel
                ]
            },
        },
        methods: {
            textFormatter: function(text){
                return this.$okaTool.textFormatter(text);
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        }
    }
</script>

<style scoped lang="scss">

    .g.pop-up-inner {

    }
</style>
